export default defineNuxtPlugin(() => {
  const router = useRouter()
  const isCardEntryRoute = (path: string) => path.startsWith('/penagihan/')
    || path.replace(/\/+$/, '') === '/dashboard/pembayaran/buat-pembayaran'
    || path.startsWith('/dashboard/pembayaran/detail/')
  let enteringCardRoute = isCardEntryRoute(window.location.pathname)

  const loadTawk = () => {
    if (enteringCardRoute)
      return
    if (document.getElementById('tawk-script'))
      return

    // Pre-configure Tawk_API before script loads
    const w = window as any
    w.Tawk_API = w.Tawk_API || {}
    w.Tawk_LoadStart = new Date()

    // Hide the default tawk.to bubble — we use our own HelpWidget as entry point
    w.Tawk_API.onLoad = function () {
      w.Tawk_API.hideWidget()

      // Add accessibility title to Tawk iframes (required for screen readers)
      document.querySelectorAll('iframe').forEach((iframe) => {
        if (!iframe.getAttribute('title')) {
          iframe.setAttribute('title', 'Live Chat Support')
        }
      })
    }

    const script = document.createElement('script')
    script.id = 'tawk-script'
    script.src = 'https://embed.tawk.to/6422f91a31ebfa0fe7f526e8/1gsk9q47h'
    script.async = true
    script.charset = 'UTF-8'
    script.setAttribute('crossorigin', '*')

    document.body.appendChild(script)
  }

  router.beforeEach((to) => {
    enteringCardRoute = isCardEntryRoute(to.path)
    if (enteringCardRoute && !isCardEntryRoute(window.location.pathname)) {
      // A full navigation gives card entry a clean document without third-party scripts.
      window.location.assign(to.fullPath)
      return false
    }
  })

  router.afterEach((to) => {
    enteringCardRoute = isCardEntryRoute(to.path)
    if (!enteringCardRoute)
      loadTawk()
  })

  // Defer Tawk loading until browser is idle to avoid blocking page render
  if ('requestIdleCallback' in window) {
    ;(window as any).requestIdleCallback(loadTawk, { timeout: 5000 })
  }
  else {
    setTimeout(loadTawk, 3000)
  }
})
